import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  CardHeader,
} from "reactstrap";
import { updatePersonContactDetails } from "common/services/persons.service";
import { tidyCountry } from "Components/Common/CountrySelect";
import PersonSheetLink from "../PersonSheetLink";
import { CONTACT_SECTIONS } from "../personSheets";

const ContactDetails = ({ person }: { person: any }) => {
  const [openFlush, setOpenFlush] = useState("1");
  const toggleFlush = (id: any) => {
    if (openFlush !== id) {
      setOpenFlush(id);
    }
  };



  return (
    <Card>
      <CardHeader className="d-flex align-items-center">
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">Contact Details</h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <PersonSheetLink
            person={person}
            title="Contact details"
            sections={CONTACT_SECTIONS}
            action="updateContactDetails"
            save={updatePersonContactDetails}
            savedMessage="Contact details saved"
          />
        </div>
      </CardHeader>

      <CardBody className="card-body px-0 pt-0">
        <Row className="g-3">
          <Accordion
            id="default-accordion-example"
            flush
            open={openFlush}
            toggle={toggleFlush}
          >
            <AccordionItem className="material-shadow">
              <AccordionHeader targetId="1">Personal Contacts</AccordionHeader>
              <AccordionBody accordionId="1">
                <Row>
                  <Col sm={6} className="">
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-phone-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">Phone: </span>
                          <span>
                            {(person?.phoneNumber &&
                              person?.phoneNumber
                                .map((el: any) => el.name || "")
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-mail-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">Email: </span>
                          <span>
                            {(person?.emailAddress &&
                              person.emailAddress
                                .map((email: any) => email.name || "")
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-map-pin-2-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">
                            Physical Address:{" "}
                          </span>
                          <span>
                            {(person?.physicalAddress &&
                              person.physicalAddress
                                .map(
                                  (physical: any) =>
                                    [physical.address, physical.city, tidyCountry(physical.country)]
                                    .filter(Boolean)
                                    .join(", ")
                                )
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} className="">
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-map-pin-user-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">
                            Postal Address:{" "}
                          </span>
                          <span>
                            {(person?.postalAddress &&
                              person.postalAddress
                                .map(
                                  (postal: any) =>
                                    [postal.address, postal.city, tidyCountry(postal.country)]
                                    .filter(Boolean)
                                    .join(", ")
                                )
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-global-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body me-1">
                            Website or Link:
                          </span>
                          <span>{person?.websiteOrLink || "Not Provided"}</span>
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ContactDetails;
